import { useQuery } from "@tanstack/react-query";
import { fetchApiKeys } from "@/api/apiKey";
import { useRequiredOrgId } from "@/hooks/useRequiredOrgId";
import { queryKeys } from "@/lib/query-keys";

export const useOrgApiKeys = () => {
  const organizationId = useRequiredOrgId();

  return useQuery({
    queryKey: queryKeys.apiKeys.all(organizationId),
    queryFn: () => fetchApiKeys(organizationId),
    enabled: !!organizationId,
  });
};
